import Immutable from 'immutable';

const DosRejectedCommentRecord = Immutable.Record({
  rejectedBy: undefined,
  rejectedComment: undefined,
  rejectedDate: undefined,
});

class DosRejectedComment extends DosRejectedCommentRecord { }

export default DosRejectedComment;



// WEBPACK FOOTER //
// ./data/IndividualDevelopmentPlans/Idp/DosRejectedComment/model.js